(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["figini-size-order"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('figini-size-order')) {
    customElements.define('figini-size-order', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        const form = this.querySelector('form');
        const select = this.querySelector('select');
        const button = this.querySelector('button[type="submit"]');
        const status = this.querySelector('.figini-status');
        const quantity = form.querySelector('[name="quantity"]');
        const variant = form.querySelector('[name="id"]');
        const express = form.querySelector('[data-express]');
        const syncQuantityButtons = () => {
          const count = Number(quantity.value);
          const minus = form.querySelector('[name="minus"]');
          const plus = form.querySelector('[name="plus"]');
          minus.disabled = quantity.disabled || count <= Number(quantity.min);
          plus.disabled = quantity.disabled || Boolean(quantity.max && count >= Number(quantity.max));
          minus.classList.toggle('disabled', minus.disabled);
          plus.classList.toggle('disabled', plus.disabled);
        };
        quantity.addEventListener('change', syncQuantityButtons);
        form.querySelectorAll('.quantity__button').forEach(control => {
          control.addEventListener('click', event => {
            event.preventDefault();
            if (quantity.disabled) return;
            if (event.currentTarget.name === 'plus') quantity.stepUp();
            else quantity.stepDown();
            quantity.dispatchEvent(new Event('change', { bubbles: true }));
          });
        });
        const update = () => {
          const option = select.selectedOptions[0];
          const valid = Boolean(select.value && option.dataset.variant && !option.disabled);
          const made = valid && option.dataset.made === 'true';
          if (valid) {
            const price = this.closest('product-info')?.querySelector('.price');
            if (price) {
              price.classList.toggle('price--on-sale', option.dataset.sale === 'true');
              price.classList.remove('price--sold-out', 'price--no-compare');
              const regular = price.querySelector('.price__regular .price-item--regular');
              const sale = price.querySelector('.price-item--sale');
              const compare = price.querySelector('.price__sale s.price-item--regular');
              if (regular) regular.textContent = option.dataset.price;
              if (sale) sale.textContent = option.dataset.price;
              if (compare) compare.textContent = option.dataset.compare;
            }
            const color = this.querySelector('.figini-color-value');
            if (color) color.textContent = option.dataset.color;
          }
          variant.value = valid ? option.dataset.variant : '';
          variant.disabled = !valid;
          variant.dispatchEvent(new Event('change', { bubbles: true }));
          form.querySelector('[data-production]').disabled = !made;
          button.disabled = !valid;
          button.removeAttribute('aria-disabled');
          button.classList.toggle('button--primary', made);
          button.classList.toggle('button--secondary', !made);
          button.querySelector('span').textContent = made ? button.dataset.order : button.dataset.add;
          status.textContent = made ? status.dataset.made : '';
          status.hidden = !made;
          if (express) express.hidden = !valid || made;
          quantity.disabled = !valid;
          quantity.value = '1';
          if (valid && !made && option.dataset.max) quantity.max = option.dataset.max;
          else quantity.removeAttribute('max');
          quantity.dispatchEvent(new Event('change', { bubbles: true }));
          this.querySelector('product-form').handleErrorMessage?.();
        };
        select.addEventListener('change', update);
        form.addEventListener('submit', event => {
          if (!select.value || !variant.value || !form.checkValidity()) {
            event.preventDefault();
            event.stopImmediatePropagation();
            form.reportValidity();
          }
        }, true);
        update();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
